import styles from './InvestigationNotes.module.scss';
import { useGetNotesQuery } from '@customer/store/apis/investigationsApi';
import { useParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '@customer/store/hooks';
import { skipToken } from '@reduxjs/toolkit/query';
import { useCallback } from 'react';
import { openSidePanel, SidePanel } from '@customer/store/slices/globalSlice';
import Notes from '../../../../components/data-display/notes/Notes';

export const InvestigationNotes = () => {
  const { investigationId } = useParams();
  const dispatch = useAppDispatch();

  const siteId = useAppSelector(state => state.auth.siteId);

  const { currentData } = useGetNotesQuery(investigationId ?? skipToken, {
    refetchOnMountOrArgChange: 10,
    skip: typeof investigationId === 'undefined' || typeof siteId === 'undefined',
  });

  const onShowAddNoteForm = useCallback(() => {
    dispatch(openSidePanel({ sidePanel: SidePanel.AddInvestigationNote }));
  }, [dispatch]);

  return (
    <div className={styles.container}>
      <Notes
        countTrans="NotesCount"
        noneTrans="NoNotes"
        entityId={investigationId}
        notes={currentData}
        onAdd={onShowAddNoteForm}
      />
    </div>
  );
};

export default InvestigationNotes;
